import * as React from "react";
import { Component } from "react";
import MainLayout from "../../layouts/MainLayout";
import Table from "../../components/Table";
import { __, getURLParam, mapStateToProps, setTableParams } from "../../core/utils";
import { createSuperadminSidebar } from "../../redux/actions/general/sidebar";
import { listActiveModules } from "../../redux/actions/general/active_modules";
import Tooltip from "../../components/Tooltip";
import * as _ from "lodash";
import { setPlusActions } from "../../redux/actions/general/plus";
import DeleteIcon from "../../assets/images/delete-15x15.svg";
import { hideAlertbox, showAlertbox } from "../../redux/actions/general/alertbox";
import { setNotification } from "../../redux/actions/general/notification";
import {
	deleteUnitGroups,
	listUnitGroups,
	readUnitGroup
} from "../../redux/actions/table/superadmin/unit_groups";
import UnitGroupsFlyout from "../../flyouts/superadmin/unit_groups/UnitGroupsFlyout";
import TableNA from "../../components/TableNA";

@mapStateToProps(state => ({
	superadmin: state.auth.superadmin,
	table: state.table["superadmin_unit_groups"],
}))
class UnitGroups extends Component {
	constructor(props) {
		super(props);

		this.state = {
			preview: null,
		};
	}

	componentDidMount() {
		listActiveModules();
		createSuperadminSidebar(); //don't forget to add new routes in sidebar.js

		const { superadmin } = this.props;

		superadmin.add_unit_group && setPlusActions([{
			title: "Add unit group",
			onClick: () => setTableParams('superadmin_unit_groups', {
				add_unit_group_wizard: true
			})
		}]);
	}

	componentDidUpdate(prevProps) {
		if (this.props.table.clicked_row && this.props.table.clicked_row !== prevProps.table.clicked_row) {
			if (!prevProps.table.clicked_row) {
				this.setState({ preview: undefined });
			}

			readUnitGroup(this.props.table.clicked_row).then(({ response }) => {
				this.setState({ preview: response.data });
			});
		}
	}

	render() {
		const { superadmin, auth } = this.props;

		const columns = [
			{
				key: "id",
				name: "ID",
				width: 60,
				sortable: false
			},
			{
				key: "name",
				name: "Name",
				value: name => _.get(name, _.get(auth, 'language_id', 1)),
			},
			{
				key: "priority",
				name: "Priority",
				width: 60,
			},
			{
				key: "units",
				name: "Attached units",
				width: 200,
				value: units => {
					const joined_units = _.join(units, ', ');

					return _.isEmpty(units) ? <TableNA /> : <Tooltip text={joined_units}>{joined_units}</Tooltip>;
				},
				sortable: false
			},
		];

		const singleActions = (unit_group_id) => {
			return [
				<Tooltip text="Delete selected unit group" key={_.uniqueId()}>
					<DeleteIcon
						onClick={e => {
							e.stopPropagation();

							showAlertbox({
								color: "red",
								title: __('general.alert.are-you-sure'),
								description: "Do you really want to delete the selected unit group?\n\nThis process cannot be undone.",
								buttons: [
									{
										color: 'lightGray',
										text: __('general.alert.no-close'),
										onClick: 'close'
									},
									{
										color: 'gray',
										text: __('general.alert.yes-delete'),
										onClick: () => {
											deleteUnitGroups([unit_group_id]).then(() => {
												hideAlertbox();

												setNotification("The selected unit group has been deleted.");
												listUnitGroups();

												setTableParams('superadmin_unit_groups', {
													actioned_row: undefined
												});
											});
										},
									}
								]
							})
						}}
					/>
				</Tooltip>
			];
		};

		const groupActions = (unit_groups_ids) => [
			<Tooltip text="Delete selected unit groups" key={_.uniqueId()}>
				<DeleteIcon
					onClick={e => {
						e.stopPropagation();

						showAlertbox({
							color: "red",
							title: __('general.alert.are-you-sure'),
							description: "Do you really want to delete these unit groups?\n\nThis process cannot be undone.",
							buttons: [
								{
									color: 'lightGray',
									text: __('general.alert.no-close'),
									onClick: 'close'
								},
								{
									color: 'gray',
									text: __('general.alert.yes-delete'),
									onClick: () => {
										deleteUnitGroups(unit_groups_ids).then(() => {
											hideAlertbox();

											setNotification("The selected unit groups have been deleted.");
											listUnitGroups();

											setTableParams('superadmin_unit_groups', {
												selected_rows: []
											});
										});
									},
								}
							]
						})
					}}
				/>
			</Tooltip>
		];

		const preview = (
			<UnitGroupsFlyout
				data={this.state.preview}
				readAction={unit_group_id => {
					return new Promise(resolve => {
						readUnitGroup(getURLParam('id') || unit_group_id).then(({ response }) => {
							this.setState({ preview: response.data });

							resolve(response);
						});
					});
				}}
			/>
		);

		return (
			<Table
				listAction={listUnitGroups}
				name="superadmin_unit_groups"
				groupActions={superadmin.delete_unit_group && groupActions}
				singleActions={superadmin.delete_unit_group && singleActions}
				title={__("modules.submodules.title.unit-groups")}
				preview={this.state.preview ? preview : []}
				columns={columns}
			/>
		);
	}
}

export default UnitGroups;
